export default function CustomerAnalysis() {
  return (
    <section className="sales-layout__page">
      <h1>Kundenauswertung</h1>
      <p>Die Kundenauswertungsfunktion ist noch in Entwicklung.</p>
    </section>
  );
}
